'use strict';

import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {
	Button,
	Icon,
	ButtonGroup,
	InputCollectionSelect,
	SingleDatePickerInput,
} from 'dumb';
import { ModalRow } from 'dumb/modal';

// constants/phrases
import constants from 'services/constants';
import phrases from './../../../workplaceWaitingTimeGrids.phrases';

// lodash
import _isEmpty from 'lodash/isEmpty';

class WorkplaceWaitingTimeGridsBatchStepForm extends Component {
	editStoreEntry(e, type) {
		const { updateBatchForm, resetSelection, workplaceReduxKey } = this.props;

		let value;
		if (e === null) value = e;
		else value = e.target ? e.target.value : e;

		// if we cleared the select, also clear the selected rows in overlay table
		if (type === 'workplace' && _isEmpty(value)) {
			resetSelection(workplaceReduxKey);
		}

		updateBatchForm({
			[type]: value,
		});
	}

	_getSelectedDate(date, name) {
		if (date) return moment.utc(date).format(constants.shortDate);

		return name === 'from'
			? moment.utc().format(constants.shortDate)
			: '9999-12-31';
	}

	render() {
		const {
			batchFormData,
			toggleOverlay,
			workplaceReduxKey,
			workplaceFilter,
		} = this.props;

		return (
			<>
				<ModalRow>
					<ButtonGroup type="full-width">
						<InputCollectionSelect
							id="posConfiguration"
							label={phrases.MODAL_BATCH_STEP_WORKPLACE}
							placeholder={phrases.MODAL_BATCH_STEP_WORKPLACE_PLACEHOLDER}
							value={batchFormData.workplace}
							handleChange={(key, value) =>
								this.editStoreEntry(value, 'workplace')
							}
							required
							multi
							cache
							apiPath="/administration/workplaces"
							params={{
								limit: 30,
								filter: workplaceFilter,
							}}
							optionFormat={(entry) => ({
								value: entry,
								label: entry.name,
							})}
							inputFilterFormat={(input) => `:name=like='%${input}%'`}
						/>

						<Button
							type="inverted"
							shadow
							size="large"
							onClick={() => toggleOverlay(workplaceReduxKey)}>
							<Icon name="more" />
						</Button>
					</ButtonGroup>
				</ModalRow>

				<ModalRow>
					<SingleDatePickerInput
						id="from"
						label={phrases.MODAL_BATCH_FROM}
						onChange={(event) => this.editStoreEntry(event, 'from')}
						selectedDate={this._getSelectedDate(batchFormData.from, 'from')}
						noClockButton
						clearable
					/>
				</ModalRow>

				<ModalRow>
					<SingleDatePickerInput
						id="to"
						label={phrases.MODAL_BATCH_TO}
						onChange={(event) => this.editStoreEntry(event, 'to')}
						selectedDate={this._getSelectedDate(batchFormData.to, 'to')}
						noClockButton
						clearable
					/>
				</ModalRow>
			</>
		);
	}
}

WorkplaceWaitingTimeGridsBatchStepForm.propTypes = {
	batchFormData: PropTypes.object,
	updateBatchForm: PropTypes.func,
	toggleOverlay: PropTypes.func,
	resetSelection: PropTypes.func,
	workplaceReduxKey: PropTypes.string,
	workplaceFilter: PropTypes.string,
};

export default WorkplaceWaitingTimeGridsBatchStepForm;
